export default function regexTester({ value, type }) {
  const config = {
    email: {
      regex:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      toLowerCase: true,
    },
  };
  return type in config
    ? config[type].regex.test(
        config[type].toLowerCase ? String(value).toLowerCase() : String(value)
      )
    : false;
}
